import axios from "axios";
import { toast } from "react-toastify";
export const GetRecoveryReport = (data) => {
  return {
    type: "get_allrecoveryreport",
    payload: data,
    loader: false,
  };
};
export function getrecoveryreport() {
  let pgurl = `${
    process.env.REACT_APP_API_URL
  }Reports/RecoverySheet?ProjectId=${localStorage.getItem("ProjectId")}`;
  if (localStorage.getItem("ProjectId") === null) {
    pgurl = `${process.env.REACT_APP_API_URL}Reports/RecoverySheet`;
  }
  return (dispatch) => {
    axios({
      url: pgurl,
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetRecoveryReport(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
